export const CANCELLABLE_PROMISE_PRIVATE = Symbol('cancellable-promise-private');
//# sourceMappingURL=privates.js.map